export interface User {
  id: string;
  name: string;
  email: string;
  password: string; // In production, this would be hashed
  role: 'super_admin' | 'admin' | 'manager' | 'staff' | 'viewer' | 'chef';
  avatar?: string;
  phone?: string;
  bio?: string;
  location?: string;
  status: 'active' | 'inactive';
  createdAt: string;
  lastLogin?: string;
  permissions: string[]; // User permissions based on role
  restaurantId?: string;
  tenantId?: string; // Alias for restaurantId to support backend compatibility
  branchId?: string;
  branchName?: string;
}

// Helper function to get permissions based on role
export const getPermissionsByRole = (role: User['role']): string[] => {
  switch (role) {
    case 'super_admin':
      return ['dashboard', 'orders', 'view_order_details', 'menus', 'tables', 'customers', 'reviews', 'analytics', 'reports', 'settings', 'users', 'roles'];
    case 'admin':
      return ['dashboard', 'orders', 'view_order_details', 'menus', 'tables', 'customers', 'reviews', 'analytics', 'reports', 'settings', 'users'];
    case 'manager':
      return ['dashboard', 'orders', 'view_order_details', 'menus', 'tables', 'customers', 'reviews', 'analytics'];
    case 'chef':
      return ['dashboard', 'orders', 'view_order_details', 'menus', 'tables'];
    case 'staff':
      return ['dashboard', 'orders', 'view_order_details', 'menus', 'tables'];
    case 'viewer':
      return ['dashboard', 'analytics'];
    default:
      return ['dashboard'];
  }
};

export const users: User[] = [
  {
    id: '1',
    name: 'Admin User',
    email: 'admin@restaurant.com',
    password: 'Admin@2024!Secure',
    role: 'admin',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop',
    status: 'active',
    createdAt: '2024-01-01',
    lastLogin: '2024-02-22',
    permissions: getPermissionsByRole('admin'),
    restaurantId: 'restaurant-001',
    tenantId: 'restaurant-001', // Alias for restaurantId
    branchId: 'branch-main-001',
    branchName: 'Main Branch'
  },
  {
    id: '2',
    name: 'John Manager',
    email: 'manager@restaurant.com',
    password: 'Manager#2024!Strong',
    role: 'manager',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop',
    status: 'active',
    createdAt: '2024-01-15',
    lastLogin: '2024-02-21',
    permissions: getPermissionsByRole('manager'),
    restaurantId: 'restaurant-001',
    tenantId: 'restaurant-001', // Alias for restaurantId
    branchId: 'branch-002',
    branchName: 'Downtown Branch'
  },
  {
    id: '3',
    name: 'Sarah Staff',
    email: 'staff@restaurant.com',
    password: 'Staff$2024!Access',
    role: 'staff',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop',
    status: 'active',
    createdAt: '2024-02-01',
    lastLogin: '2024-02-20',
    permissions: getPermissionsByRole('staff'),
    restaurantId: 'restaurant-001',
    tenantId: 'restaurant-001', // Alias for restaurantId
    branchId: 'branch-003',
    branchName: 'Airport Branch'
  },
  {
    id: '4',
    name: 'Mike Viewer',
    email: 'viewer@restaurant.com',
    password: 'Viewer!2024#ReadOnly',
    role: 'viewer',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop',
    status: 'active',
    createdAt: '2024-02-10',
    lastLogin: '2024-02-19',
    permissions: getPermissionsByRole('viewer'),
    restaurantId: 'restaurant-001',
    tenantId: 'restaurant-001', // Alias for restaurantId
    branchId: 'branch-main-001',
    branchName: 'Main Branch'
  }
];